import {
	differenceInCalendarWeeks as differenceInCalendarWeeksReal,
	endOfWeek as endOfWeekReal,
	format as formatReal,
	getWeek as getWeekReal,
	isSameWeek as isSameWeekReal,
	parse as parseReal,
	setDay as setDayReal,
	startOfWeek as startOfWeekReal,
} from 'date-fns';

const DEFAULT_DATE_FNS_OPTIONS: {
	weekStartsOn?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
} = {
	weekStartsOn: 1, // Start on monday. Week is monday -> sunday.
};

// Wrap a date-fns method with default options param
const mixinDefaultOptions = <p extends (...args: any[]) => any>(fn: p) => {
	return function (this: any, ...theArgs: any[]) {
		const lastIndex = fn.length - 1;
		if (fn.length === theArgs.length) {
			theArgs[lastIndex] = {
				...DEFAULT_DATE_FNS_OPTIONS,
				...theArgs[lastIndex],
			};
		} else {
			theArgs[lastIndex] = DEFAULT_DATE_FNS_OPTIONS;
		}
		return fn.apply(this, theArgs);
	} as p;
};

export const differenceInCalendarWeeks: typeof differenceInCalendarWeeksReal = mixinDefaultOptions(
	differenceInCalendarWeeksReal,
);
export const endOfWeek: typeof endOfWeekReal = mixinDefaultOptions(endOfWeekReal);
export const format: typeof formatReal = mixinDefaultOptions(formatReal);
export const getWeek: typeof getWeekReal = mixinDefaultOptions(getWeekReal);
export const isSameWeek: typeof isSameWeekReal = mixinDefaultOptions(isSameWeekReal);
export const parse: typeof parseReal = mixinDefaultOptions(parseReal);
export const setDay: typeof setDayReal = mixinDefaultOptions(setDayReal);
export const startOfWeek: typeof startOfWeekReal = mixinDefaultOptions(startOfWeekReal);
